export const shapes = {
  borderRadius: {
    sm: '5px',
    xm: '8px',
    md: '10px',
    xmd: '16px',
    lg: '20px',
    full: '50%'
  },
  borderWidth: {
    none: '0px solid',
    thin: '1px solid',
    md: '2px solid'
  }
} as const
